import { propertyTenureService } from '@/services/api/propertyTenure.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { propertyTenureModel } from '@/models/api/propertyTenure.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const PROPERTY_TENURE_MODULE = "api/propertyTenure";

// ACTIONS
export const GET_ALL_PROPERTY_TENURE = 'getAllPropertyTenure';
export const CREATE_PROPERTY_TENURE = 'createPropertyTenure';
export const GET_PROPERTY_TENURE = 'getPropertyTenure';
export const UPDATE_PROPERTY_TENURE = 'updatePropertyTenure';
export const UPDATE_PROPERTY_TENURE_STATUS = 'updatePropertyTenureStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PROPERTY_TENURE_SUCCESS = "allPropertyTenureSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PROPERTY_TENURE_SUCCESS = "getPropertyTenureSuccess";

export const actions = {
    [GET_ALL_PROPERTY_TENURE]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        propertyTenureService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PROPERTY_TENURE_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_PROPERTY_TENURE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyTenureService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_TENURE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PROPERTY_TENURE]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return propertyTenureService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PROPERTY_TENURE_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PROPERTY_TENURE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyTenureService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_TENURE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_PROPERTY_TENURE_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return propertyTenureService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_TENURE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_PROPERTY_TENURE_SUCCESS](state, {data}) {
        let propertyTenureList = data.data || [];
        state.list.data = propertyTenureList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = propertyTenureList.map(item => propertyTenureModel(item));
        }
    },
    [GET_PROPERTY_TENURE_SUCCESS](state, data) {
        state.details = propertyTenureModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
